"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (siteId, dataLayerData) => {
    return {
        countryid: dataLayerData.tenant,
        siteId,
    };
};
//# sourceMappingURL=create.econda.data.js.map